@if (allowedTabs.includes(activeAppointmentCreateTab)) {
<div class="tab-list-header">
    <div class="content-wrapper">
        @if (!isMUCEnabled()) {
        <a
            class="tab-list-item active"
            [class.active]="activeAppointmentCreateTab === TAN"
            [routerLink]="[oneTimeLink]"
        >
            <span>{{ "APPOINTMENT.CREATE.TAN-TAB" | translate }}</span>
        </a>
        } @if (isMUCEnabled()) {
        <a
            class="tab-list-item active"
            [class.active]="activeAppointmentCreateTab === MULTIUSER"
            [routerLink]="[multiuserLink]"
        >
            <span>
                {{ "APPOINTMENT.CREATE.CREATE-APPOINTMENT" | translate }}
            </span>
        </a>
        } @if (!hideTabBasedOnInstitution) {
        <a
            class="tab-list-item"
            [class.active]="activeAppointmentCreateTab === CONSULTATIONHOURS"
            [routerLink]="[consultationHoursLink]"
        >
            <span>
                {{ "APPOINTMENT.CREATE.CONSULTATION-HOURS" | translate }}
            </span>
        </a>
        }
    </div>
</div>
}
<router-outlet></router-outlet>
